/** Página Request a demo: la solicitud se guarda y llega a info@kuantabridge.com. */
import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import Marco, { Navegacion, useMeta } from './Marco';
import { useT, useIdiomaSitio } from './idioma';
import { enviarDemo } from './planes';

export default function Demo() {
  const T = useT();
  const t = T.demo;
  const idioma = useIdiomaSitio(s => s.idioma);
  useMeta(T.meta.demo);
  const [params] = useSearchParams();
  const [volumen, setVolumen] = useState(t.volumenes[0]);
  const [estado, setEstado] = useState('form');   // form | enviando | listo | error

  const enviar = async (e) => {
    e.preventDefault();
    const f = e.currentTarget.elements;
    setEstado('enviando');
    try {
      await enviarDemo({
        nombre: f.nombre.value, correo: f.correo.value, empresa: f.empresa.value, telefono: f.telefono.value,
        pais: f.pais.value, sistemaActual: f.hoy.value, idioma: f.idioma.value, volumen, sitio: f.sitio.value,
      });
      setEstado('listo');
    } catch {
      setEstado('error');
    }
  };

  return (
    <Marco>
      <div className="noche" style={{ minHeight: '100vh' }}>
        <Navegacion tono="oscura" />
        <main className="caja dos" style={{ paddingTop: 56, paddingBottom: 96, alignItems: 'flex-start' }}>
          <div className="texto" style={{ paddingTop: 12 }}>
            <div className="ojo">{t.ojo}</div>
            <h1 className="display" style={{ fontSize: 'clamp(38px,4.6vw,60px)', margin: '16px 0 0' }}>{t.titulo}</h1>
            <p className="suave" style={{ fontSize: 19, margin: '22px 0 0' }}>{t.texto}</p>
            <ul className="puntos" style={{ marginTop: 34 }}>{t.puntos.map(p => <li key={p}><div><b style={{ fontWeight: 400 }}>{p}</b></div></li>)}</ul>
            <div style={{ marginTop: 44, borderTop: '1px solid rgba(255,255,255,.14)', paddingTop: 24, fontSize: 14.5, color: '#AEB4DD' }}>{t.respuesta}</div>
          </div>

          <div className="medio" style={{ flexBasis: 440, background: '#fff', color: '#171A26', borderRadius: 20, padding: 36, boxShadow: '0 40px 80px -40px rgba(0,0,0,.6)' }}>
            {estado === 'listo' ? (
              <div style={{ textAlign: 'center', padding: '48px 8px' }} role="status">
                <h2 className="display" style={{ fontWeight: 800, fontSize: 28 }}>{t.listo}</h2>
                <p className="suave" style={{ margin: '10px auto 0', maxWidth: 360 }}>{t.listoTexto}</p>
                <button type="button" className="pildora borde-claro" style={{ marginTop: 26, borderRadius: 10 }} onClick={() => setEstado('form')}>{t.otra}</button>
              </div>
            ) : (
              <form onSubmit={enviar} style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
                <h2 className="display" style={{ fontWeight: 800, fontSize: 26 }}>{t.form}</h2>
                <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap' }}>
                  <div className="campo" style={{ flex: '1 1 200px' }}><label htmlFor="d-nombre">{t.nombre}</label><input id="d-nombre" name="nombre" required autoComplete="name" /></div>
                  <div className="campo" style={{ flex: '1 1 200px' }}><label htmlFor="d-correo">{t.correo}</label><input id="d-correo" name="correo" type="email" required autoComplete="email" defaultValue={params.get('correo') || ''} /></div>
                </div>
                <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap' }}>
                  <div className="campo" style={{ flex: '1 1 200px' }}><label htmlFor="d-empresa">{t.empresa}</label><input id="d-empresa" name="empresa" required autoComplete="organization" /></div>
                  <div className="campo" style={{ flex: '1 1 200px' }}><label htmlFor="d-telefono">{t.telefono}</label><input id="d-telefono" name="telefono" type="tel" autoComplete="tel" /></div>
                </div>
                <fieldset style={{ border: 0, padding: 0, margin: 0 }}>
                  <legend>{t.volumen}</legend>
                  <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 8 }}>
                    {t.volumenes.map(v => <button key={v} type="button" className="opcion" aria-pressed={volumen === v} onClick={() => setVolumen(v)}>{v}</button>)}
                  </div>
                </fieldset>
                <div className="campo"><label htmlFor="d-pais">{t.pais}</label><select id="d-pais" name="pais">{t.paises.map(p => <option key={p}>{p}</option>)}</select></div>
                <div className="campo"><label htmlFor="d-hoy">{t.hoy}</label><select id="d-hoy" name="hoy">{t.hoyOpciones.map(p => <option key={p}>{p}</option>)}</select></div>
                <div className="campo"><label htmlFor="d-idioma">{t.idioma}</label><select id="d-idioma" name="idioma" defaultValue={idioma === 'es' ? 'Español' : 'English'}>{t.idiomas.map(p => <option key={p}>{p}</option>)}</select></div>
                {/* Trampa para bots: invisible para personas */}
                <input name="sitio" tabIndex={-1} autoComplete="off" aria-hidden="true" style={{ position: 'absolute', left: -9999, width: 1, height: 1 }} />
                {estado === 'error' && <p role="alert" style={{ color: '#922E23', margin: 0, fontSize: 14 }}>{t.error}</p>}
                <button type="submit" className="pildora primaria" style={{ borderRadius: 10, minHeight: 52, marginTop: 6 }} disabled={estado === 'enviando'}>{estado === 'enviando' ? t.enviando : t.enviar}</button>
                <p className="suave" style={{ fontSize: 13, margin: 0 }}>{t.privacidad}</p>
              </form>
            )}
          </div>
        </main>
        <div className="caja" style={{ paddingBottom: 24 }}><Link to="/" style={{ color: '#C9CEEA', fontSize: 15 }}>← {t.volver}</Link></div>
      </div>
    </Marco>
  );
}
